import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IArrow } from 'src/app/interfaces/iarrow';

@Component({
  selector: 'quant-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [CommonModule],
})
export class TooltipComponent {
  @Input() arrow: IArrow = 'bottom';
  @Input() content: string = '';

  displayTooltip: boolean = false;

  showTooltip(): void {
    this.displayTooltip = true;
    setTimeout(() => {
      this.displayTooltip = false;
    }, 2000);
  }
}
